import type { ReactNode } from "react";

import { locateHighlight, type SummaryHighlight } from "./summaryHighlights";

/** Wrap the validated highlight span in <strong>; miss → plain paragraph text. */
export function paintParagraphWithHighlight(
  paragraph: string,
  highlight: SummaryHighlight | undefined,
): ReactNode {
  if (!highlight) return paragraph;
  const located = locateHighlight(paragraph, highlight.text);
  if (!located.ok || located.start == null || located.end == null) {
    return paragraph;
  }
  const before = paragraph.slice(0, located.start);
  const mid = paragraph.slice(located.start, located.end);
  const after = paragraph.slice(located.end);
  return (
    <>
      {before}
      <strong className="font-bold">{mid}</strong>
      {after}
    </>
  );
}

export function highlightForParagraph(
  highlights: SummaryHighlight[] | null | undefined,
  paragraphIndex: number,
): SummaryHighlight | undefined {
  return (highlights ?? []).find((h) => h.p === paragraphIndex);
}
